import { render } from "./emptyCart.vue?vue&type=template&id=44fc170e"
import script from "./emptyCart.vue?vue&type=script&lang=js"
export * from "./emptyCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__